import style from '../Home.module.scss';
import {memo} from "react";
import className from 'classnames/bind';
import {
	ContentHeader,
	SidebarAccount,
	TrainingScheduleWeek,
	NoConsultationWidget,
	LowestPerformersWidget,
} from "../componets";
import {Col, Row} from "antd";

const cn = className.bind(style);

function DashboardTraining({user, fullTime}) {

	return (
		<div className={cn('dashboard')}>
			<div className={cn('sidebar')}>
				<SidebarAccount user={user} />
			</div>
			<div className={cn('content')}>
				<ContentHeader user={user} fullTime={fullTime} />
				<TrainingScheduleWeek />
				<Row gutter={20} style={{marginTop: 20}}>
					<Col xs={24} md={12}>
						<NoConsultationWidget />
					</Col>
					<Col xs={24} md={12}>
						<LowestPerformersWidget />
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default memo(DashboardTraining);
